<template>
    <div id="app">
        
        <div class="sticky-top" v-bind:style="{'height': menu.height + 'px', 'width': '100%', 'margin-bottom': '0px'}">
            
        </div>
        <div class="sticky-top" v-bind:style="{'height': menu.height + 'px', 'width': '100%', 'margin-bottom': '0px', 'position': 'fixed', 'top': '0'}">
            <div v-bind:style="{'float': 'left', 'width': menu.left + 'px', 'height': menu.height + 'px'}"
                v-if="menu.left > 0">
            </div>
            <div class="header" v-bind:style="{'width': menu.width + 'px', 'height': menu.height + 'px', 'background-image': `url(` + header.backgroundImage + `)`, 'background-repeat': 'no-repeat'}"
                v-if="viewMode === 'x-large' || viewMode === 'large' || viewMode === 'medium'">
                <div v-if="menu.leftSide.width > 0" v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': menu.leftSide.width + 'px', 'height': menu.leftSide.height - 30 + 'px', 'padding-top': '10px', 'border-radius': '0 0 0 5px'}" align="center">
                    <!--
                    <div class="nav-link" v-on:click="goToHref(httpPath + '/');" id="app-logo-link" style='cursor: pointer;'></div>
                    -->
                </div>
                <div v-if="menu.centerSide.width > 0" v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': menu.centerSide.width + 'px', 'height': menu.leftSide.height - 30 + 'px', 'padding-top': '10px', 'border-radius': '0 0 0 5px'}" align="left">
                    <h3 style="font-weight: bold; color: #555555;">ООО "АИС"</h3>
                    <table style="margin-top: -5px;">
                        <tr>
                            <td v-bind:style="{width: menu.centerSide.iconColWidth + 'px'}">
                                <img alt="Адрес" src="/img/ais/address.png" v-bind:width="menu.centerSide.iconWidth">
                            </td>
                            <td>
                                <strong v-bind:style="{'color': 'blue', 'font-size': menu.centerSide.fontSize}">
                                    169300, Республика Коми, г. Ухта, ул. Первомайская, д.35А.
                                </strong>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img alt="Телефон" src="/img/ais/phone.png" v-bind:width="menu.centerSide.iconWidth">
                            </td>
                            <td>
                                <strong v-bind:style="{'color': 'blue', 'font-size': menu.centerSide.fontSize}">
                                    +7 (8216) 76-33-06
                                </strong>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img alt="E-mail" src="/img/ais/e-mail.png" v-bind:width="menu.centerSide.iconWidth">
                            </td>
                            <td>
                                <strong v-bind:style="{'color': 'blue', 'font-size': menu.centerSide.fontSize}">
                                    office@ais-center.ru
                                </strong>
                            </td>
                        </tr>
                    </table>
                    
                </div>
                <div v-if="menu.rightSide.width > 0" v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': menu.rightSide.width + 'px', 'height': menu.leftSide.height - 30 + 'px', 'padding-top': '10px', 'border-radius': '0 0 0 5px', 'padding-right': '10px'}" align="right">
                    <!--
                    <a href="https://download.teamviewer.com/download/version_13x/TeamViewerQS.exe" title="TeamViewer QS v13" target="_blank" rel="noreferrer"
                        v-bind:style="{'font-size': menu.rightSide.fontSize}">
                        Программа для удалённой поддержки
                    </a>
                    -->
                </div>
                
                <div v-bind:style="{'float': 'left', 'width': '100%', 'height': '30px', 'padding-top': '0px', 'padding-left': '0px', 'margin-top': '0px', 'border-radius': '0 0 0 0', 'background-color': '#416ca0'}" align="center"
                    v-show="viewMode === 'x-large' || viewMode === 'large' || viewMode === 'medium'">
                    
                    <ul id="main-menu" style="padding-left: 0;">
                        <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/'}"
                            v-bind:style="{'float': 'left', 'width': '100px', 'margin-left': '10px', 'padding': '0px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                            v-on:click="goToHref(httpPath + '/');">
                            Главная
                        </li>
                        
                        <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрики'}"
                            v-bind:style="{'float': 'left', 'width': '200px', 'margin-left': '10px', 'padding': '0px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px', 'list-style-type': 'none'}">
                            Сопровождение 1С
                            <ul style="padding-left: 0px; background-color: #416ca0; list-style-type: none;">
                                
                                <li v-on:click="goToHref(httpPath + '/итс');" style="list-style-type: none;">
                                    ИТС
                                </li>
                                <li v-on:click="goToHref(httpPath + '/сервисы');" style="list-style-type: none;">
                                    Сервисы
                                </li>
                                <li v-on:click="goToHref(httpPath + '/тарифы');" style="list-style-type: none;">
                                    Тарифы
                                </li>
                                <!--
                                <li v-on:click="goToHref(httpPath + '/дополнительные-работы');" style="list-style-type: none;">
                                    Дополнительные работы
                                </li>
                                -->
                                
                            </ul>
                        </li>
                        
                        <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрики'}"
                            v-bind:style="{'float': 'left', 'width': '100px', 'margin-left': '10px', 'padding': '0px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px', 'list-style-type': 'none'}">
                            Продажа
                            <ul style="padding-left: 0px; background-color: #416ca0; list-style-type: none;">
                                
                                <li v-on:click="goToHref(httpPath + '/продукция-1с');" style="list-style-type: none;">
                                    Продукция 1С
                                </li>
                                <li v-on:click="goToHref(httpPath + '/кассовое-оборудование');" style="list-style-type: none;">
                                    Кассовое оборудование
                                </li>
                                <li v-on:click="goToHref(httpPath + '/торговое-оборудование');" style="list-style-type: none;">
                                    Торговое оборудование
                                </li>
                                <li v-on:click="goToHref(httpPath + '/электронные-подписи');" style="list-style-type: none;">
                                    Электронные подписи
                                </li>
                                <li v-on:click="goToHref(httpPath + '/офд');" style="list-style-type: none;">
                                    ОФД
                                </li>
                                <li v-on:click="goToHref(httpPath + '/антивирусное-по');" style="list-style-type: none;">
                                    Антивирусное ПО
                                </li>
                                
                            </ul>
                        </li>
                        
                        <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/контакты'}"
                            v-bind:style="{'float': 'left', 'width': '100px', 'margin-left': '10px', 'padding': '0px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                            v-on:click="goToHref(httpPath + '/контакты');">
                            Контакты
                        </li>
                        
                        <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/1с-фреш'}"
                            v-bind:style="{'float': 'left', 'width': '250px', 'margin-left': '10px', 'padding': '0px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                            v-on:click="goToHref(httpPath + '/1с-фреш');">
                            1С Предприятие через интернет
                        </li>
                        
                        <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрики'}"
                            v-bind:style="{'float': 'left', 'width': '130px', 'margin-left': '10px', 'padding': '0px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px', 'list-style-type': 'none'}">
                            ПО DataMatrix
                            <ul style="padding-left: 0px; background-color: #416ca0; list-style-type: none;">
                                
                                <li v-on:click="goToHref(httpPath + '/по-datamatrix');" style="list-style-type: none;">
                                    Описание продукта
                                </li>
                                <li v-on:click="goToHref(httpPath + '/по-datamatrix-поддержка');" style="list-style-type: none;">
                                    Поддержка
                                </li>
                                <li v-on:click="goToHref(httpPath + '/по-datamatrix-продажа');" style="list-style-type: none;">
                                    Приобретение программы
                                </li>
                                
                            </ul>
                        </li>
                    </ul>
                    
                </div>
                
            </div>
            <div class="header" v-bind:style="{'width': menu.width + 'px', 'height': menu.height + 'px'}"
                v-if="viewMode === 'small'">
                <div v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': menu.leftSide.width + 'px', 'height': menu.leftSide.height + 'px'}">
                    <img v-bind:src="header.backgroundImage" alt="ООО АИС" v-bind:style="{'width': menu.width + 'px'}" />
                </div>
                <div v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': menu.centerSide.width + 'px', 'height': menu.centerSide.height + 'px'}">
                    <h3 style="font-weight: bold; color: #555555;">ООО "АИС"</h3>
                    
                    <table style="margin-top: -5px;">
                        <tr v-if="menu.centerSide.height >= 88">
                            <td v-bind:style="{width: menu.centerSide.iconColWidth + 'px'}">
                                <img alt="Адрес" src="/img/ais/address.png" v-bind:width="menu.centerSide.iconWidth">
                            </td>
                            <td colspan="3">
                                <strong v-bind:style="{'color': 'blue', 'font-size': menu.centerSide.fontSize}">
                                    169300, Республика Коми, г. Ухта, ул. Первомайская, д.35А.
                                </strong>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img alt="Телефон" src="/img/ais/phone.png" v-bind:width="menu.centerSide.iconWidth">
                            </td>
                            <td v-bind:style="{'min-width': '120px'}">
                                <strong v-bind:style="{'color': 'blue', 'font-size': menu.centerSide.fontSize}">
                                    +7 (8216) 76-33-06
                                </strong>
                            </td>
                            <td>
                                <img alt="E-mail" src="/img/ais/e-mail.png" v-bind:width="menu.centerSide.iconWidth">
                            </td>
                            <td>
                                <strong v-bind:style="{'color': 'blue', 'font-size': menu.centerSide.fontSize}">
                                    office@ais-center.ru
                                </strong>
                            </td>
                        </tr>
                    </table>
                    
                </div>
                
            </div>
        </div>
        
        <div>

            <div v-bind:style="{ 'float': 'left', 'min-height': content.height + 'px', 'width': content.left + 'px' }">

            </div>
            <div id="content" v-bind:style="{ 'float': 'left', 'min-height': content.height + 'px', 'width': content.width + 'px' }">

                <AppBody/>

            </div>
        </div>
        
        <div v-bind:style="{'position': 'fixed', 'width': '50px', 'left': mobileMenu.button.left + 'px', 'top': mobileMenu.button.top + 'px', 'z-index': '10000', 'padding': '0px'}"
            v-if='viewMode === "small"'>
            <nav class="navbar d-inline navbar-light my-0">
                <button class="navbar-toggler" type="button" v-on:click='showMobileMenu();'>
                    <span class="navbar-toggler-icon"></span>
                </button>
            </nav>
        </div>
        
        <div id='mobile-menu' class="sticky-top" v-if='viewMode === "small" && mobileMenuShow' align='center'
            style="margin-top: 50px;">
            
            <ul id="main-menu-mobile" style="padding-left: 0;">
                <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/'}"
                    v-bind:style="{'float': 'left', 'width': '96%', 'height': '50px', 'margin-left': '2%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-on:click="goToHref(httpPath + '/');">
                    Главная
                </li>
                
                
                <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрики'}"
                    v-bind:style="{'float': 'left', 'width': '96%', 'height': '50px', 'margin-left': '2%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px', 'list-style-type': 'none'}"
                    v-on:click="showHideITSMenuMobile();">
                    Сопровождение 1С (ИТС)
                </li>
                
                <li v-on:click="goToHref(httpPath + '/итс');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuITSShow">
                    ИТС
                </li>
                
                <li v-on:click="goToHref(httpPath + '/сервисы');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuITSShow">
                    Сервисы
                </li>
                
                <li v-on:click="goToHref(httpPath + '/тарифы');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuITSShow">
                    Тарифы
                </li>
                
                <!--
                <li v-on:click="goToHref(httpPath + '/дополнительные-работы');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuITSShow">
                    Дополнительные работы
                </li>
                -->
                
                
                <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрики'}"
                    v-bind:style="{'float': 'left', 'width': '96%', 'height': '50px', 'margin-left': '2%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px', 'list-style-type': 'none'}"
                    v-on:click="showHideProdazhaMenuMobile();">
                    Продажа
                </li>
                
                <li v-on:click="goToHref(httpPath + '/продукция-1с');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuProdazhaShow">
                    Продукция 1С
                </li>
                
                <li v-on:click="goToHref(httpPath + '/кассовое-оборудование');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuProdazhaShow">
                    Кассовое оборудование
                </li>
                
                <li v-on:click="goToHref(httpPath + '/торговое-оборудование');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuProdazhaShow">
                    Торговое оборудование
                </li>
                
                <li v-on:click="goToHref(httpPath + '/электронные-подписи');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuProdazhaShow">
                    Электронные подписи
                </li>
                
                <li v-on:click="goToHref(httpPath + '/офд');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuProdazhaShow">
                    ОФД
                </li>
                
                <li v-on:click="goToHref(httpPath + '/антивирусное-по');"
                    v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/рубрика/'}"
                    v-bind:style="{'float': 'left', 'width': '90%', 'height': '50px', 'margin-left': '5%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-show="mobileMenuProdazhaShow">
                    Антивирусное ПО
                </li>
                
                <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/контакты'}"
                    v-bind:style="{'float': 'left', 'width': '96%', 'height': '50px', 'margin-left': '2%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-on:click="goToHref(httpPath + '/контакты');">
                    Контакты
                </li>
                
                <li v-bind:class="{'nav-item': true, 'nav-item-active': $route.path === httpPath + '/1с-фреш'}"
                    v-bind:style="{'float': 'left', 'width': '96%', 'height': '50px', 'margin-left': '2%', 'padding': '10px ' + mainMenuPaddingLeftRight + 'px ' + '0px ' + mainMenuPaddingLeftRight + 'px'}"
                    v-on:click="goToHref(httpPath + '/1с-фреш');">
                    1С Предприятие через интернет
                </li>
                
            </ul>
            
            
        </div>
        
    </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'

import Axios from 'axios'
import AppBody from './components/AppBody.vue'

export default {
    name: 'app',
    data: function(){
        return{
            httpPath: "",
            
            header: {
                backgroundImage: ""
            },
            
            menu: {
                visible: false,
                left: 0,
                width: 0,
                height: 0,
                leftSide: {
                    width: 0,
                    height: 0
                },
                centerSide: {
                    width: 0,
                    height: 0,
                    fontSize: "",
                    iconWidth: "",
                    iconColWidth: ""
                },
                rightSide: {
                    width: 0,
                    height: 0,
                    fontSize: ""
                }
            },
            content: {
                left: 0,
                width: 0,
                height: 0
            },
            mobileMenu: {
                button: {
                    left: 0,
                    top: 0
                }
            },
            
            rubrics: [],
            
            viewMode: "",
            
            displayMode: "",
            pageWidth: 0,
            pageHeight: 0,
            leftSideWidth: 0,
            bodyMinHeight: 0,
            mainMenuLeft: 0,
            contentWidth: 0,
            headerCenterWidth: 0,
            headerSidesWidth: 0,
            mainMenuPaddingLeftRight: 0,
            mobileMenuShow: false,
            mobileMenuPaddingTopBottom: 0,
            mobileMenuButtomWidth: 0,
            mobileMenuITSShow: false,
            mobileMenuProdazhaShow: false
        };
    },
    components: {
        AppBody
    },
    created: function(){
        
        this.httpPath = this.$store.getters.httpPath;
        
        //window.addEventListener('pageshow', this.windowOnResize);
        //window.addEventListener('resize', this.windowOnResize);
        
        this.mobileMenuShow = false;
        
        this.updateRubrics();
        
    },
    mounted: function(){
        
        this.mobileMenuITSShow = false;
        this.mobileMenuProdazhaShow = false;
        
        this.windowOnResize();
        
    },
    destroyed: function(){
    },
    updated: function(){
    },
    computed:{
        windowWidth: function(){
            return this.$store.getters.windowWidth;
        },
        windowHeight: function(){
            return this.$store.getters.windowHeight;
        }
    },
    watch: {
        windowWidth: function(){
            this.windowOnResize();
        },
        windowHeight: function(){
            this.windowOnResize();
        }
    },
    methods: {
        windowOnResize: function(){
            
            this.menu.visible = true;
            
            //this.viewMode = "x-large";
            this.viewMode = "large";
            //this.menu.width = 1600;
            this.menu.width = 1200;
            this.menu.height = 150 + 10;
            this.header.backgroundImage = "/img/ais.jpg";
            
            this.menu.leftSide.width = 170;
            this.menu.centerSide.width = 600;
            this.menu.rightSide.width = 430;
            
            this.menu.centerSide.fontSize = "medium";
            this.menu.centerSide.iconWidth = "24px";
            this.menu.centerSide.iconColWidth = "30";
            
            this.menu.rightSide.fontSize = "medium";
            
            //if(this.windowWidth < 1600){
            //    this.viewMode = "large";
            //    this.menu.width = 1200;
            //    this.header.backgroundImage = "/img/gazeta-uhta.jpg";
            //}
            
            if(this.windowWidth < 1200){
                this.viewMode = "medium";
                this.menu.width = 800;
                this.header.backgroundImage = "/img/ais-800.jpg";
                
                this.menu.leftSide.width = 130;
                this.menu.centerSide.width = 420;
                this.menu.rightSide.width = 250;
                
                this.menu.centerSide.fontSize = "small";
                this.menu.centerSide.iconWidth = "18px";
                this.menu.centerSide.iconColWidth = "22";
                
                this.menu.rightSide.fontSize = "small";
                
            }
            
            if(this.windowWidth < 810){
                this.viewMode = "small";
                this.menu.width = this.windowWidth;
                this.menu.height = this.windowWidth / 800 * 120;
                this.mobileMenu.button.left = this.windowWidth - 80;
                this.mobileMenu.button.top = 5;
                this.header.backgroundImage = "/img/ais-mobile.jpg";
                
                this.menu.leftSide.width = this.menu.height + 10;
                this.menu.leftSide.height = this.menu.height;
                
                this.menu.centerSide.width = this.menu.width - this.menu.leftSide.width;
                this.menu.centerSide.height = this.menu.height;
                
            }
            
            this.menu.left = (this.windowWidth - this.menu.width) / 2;
            
            this.menu.leftSide.height = this.menu.height;
            this.menu.centerSide.height = this.menu.height;
            this.menu.rightSide.height = this.menu.height;
            
            this.content.left = this.menu.left;
            this.content.width = this.menu.width;
            this.content.height = this.windowHeight - this.menu.height - 0;
            
            this.$store.dispatch('setViewMode', this.viewMode);
            this.$store.dispatch('setContentWidth', this.content.width - 10);
            this.$store.dispatch('setContentHeight', this.content.height - 10);
            this.$store.dispatch('setContentLeft', this.content.left);
            this.$store.dispatch('setContentTop', this.menu.height);
            
            this.$emit("window-resize");
            
        },
        updateRubrics: function(){
            
            this.msg = "";
            Axios
            .post('/api/rubrics-list/')
            .then(response => {
                this.msg = "";
                this.rubrics = response.data.rubrics;
            })
            .catch(e => {
                this.msg = e;
            });
            
        },
        showMobileMenu: function(){
            this.mobileMenuShow = !this.mobileMenuShow;
        },
        showHideITSMenuMobile: function(){
            this.mobileMenuITSShow = !this.mobileMenuITSShow;
        },
        showHideProdazhaMenuMobile: function(){
            this.mobileMenuProdazhaShow = !this.mobileMenuProdazhaShow;
        },
        rubricOnClick(rubricId){
            this.goToHref(this.httpPath + "/рубрика/" + rubricId);
        },
        goToHref: function(href){
            this.mobileMenuShow = false;
            //window.scrollTo(0, 0);
            this.$router.push(href);
        }
    }
}
</script>

<style>
    
    body{
        /*background-color: #cee;*/
        /*background-color: #339;*/
        background-color: #DDD;
        /*background-image: url("/img/background.jpg");*/
        /*background-image: url("/img/background-stars.jpg");*/
        background-size: cover;
        background-attachment: fixed;
        overflow-y: scroll;
    }

    .disabled{

        pointer-events: none;

        /* for "disabled" effect */
        opacity: 0.5;
        -ms-user-select: none;
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;

    }
    
    #header{
        padding-top: 5pt;
        padding-bottom: 5pt;
        margin-bottom: 5pt;
        background-color: #fff;
        background-image: url("/img/background-header.jpg");
        /*background-image: url("/img/background.png");*/
        /*box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);*/
        border-radius: 0px 0px 0px 0px;
    }

    #main-menu{
        /*min-height: 100vh;*/
        /*box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);*/
    }

    #main-menu .nav-item{
        margin-bottom: 1px;
        margin-top: 3px;
        /*background-image: url("/img/background.png");*/
        box-shadow: 0.0pt 0.2pt 1pt rgba(122,122,122,1);
        border-radius: 5pt;

        -ms-user-select: none; /** Для эксплорера */
        -moz-user-select: none; /** Для мозилы */
        -khtml-user-select: none; /** Для конкверора */
        -webkit-user-select: none; /** Для Сафари и Хрома */

        /*color: #007bff;*/
        color: #ffffff;
        /*background-color: #fff;*/

        cursor: pointer;
        list-style: none;

    }

    #main-menu .nav-item:hover{
        /*box-shadow: 0.0pt 0.0pt 3pt rgba(22,22,255,1);*/
        /*background-image: url("/img/background-content.png");*/
        color: #85bae2;
    }

    #main-menu .nav-item-active{
        /*color: #fff;*/
        color: #85bae2;
        /*background-color: #007bff;*/
    }

    #main-menu .nav-item-active:hover{
        /*box-shadow: 0.0pt 0.0pt 3pt rgba(255,255,255,1);*/
    }

    #main-menu-hidden{
        padding: 5pt;
        margin: 5pt;
    }

    #main-menu-hidden .nav-item{
        box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);
        background-color: white;
        margin: 1px;
    }
    
    
    #mobile-menu{
        
        position: fixed;
        z-index: 10000;
        margin-left: 5%;
        width: 90%;
        left: 0px;
        padding: 5px;
        padding-bottom: 10px;
        /*background: white;*/
        background-image: url("/img/black-10.png");
        
        /*box-shadow: 0.0pt 0.2pt 5px rgba(0,0,0,1.0);*/
        border-radius: 10px;
        
    }

    #main-menu-mobile{
        /*min-height: 100vh;*/
        /*box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);*/
    }

    #main-menu-mobile .nav-item{
        margin-bottom: 1px;
        margin-top: 3px;
        /*background-image: url("/img/background.png");*/
        box-shadow: 0.0pt 0.2pt 1pt rgba(122,122,122,1);
        border-radius: 5pt;

        -ms-user-select: none; /** Для эксплорера */
        -moz-user-select: none; /** Для мозилы */
        -khtml-user-select: none; /** Для конкверора */
        -webkit-user-select: none; /** Для Сафари и Хрома */

        color: #007bff;
        background-color: #fff;

        cursor: pointer;
        list-style: none;

    }

    #main-menu-mobile .nav-item:hover{
        /*box-shadow: 0.0pt 0.0pt 3pt rgba(22,22,255,1);*/
        /*background-image: url("/img/background-content.png");*/
        color: #85bae2;
    }

    #main-menu-mobile .nav-item-active{
        color: #fff;
        background-color: #007bff;
    }

    #main-menu-mobile .nav-item-active:hover{
        /*box-shadow: 0.0pt 0.0pt 3pt rgba(255,255,255,1);*/
    }

    #main-menu-mobile-hidden{
        padding: 5pt;
        margin: 5pt;
    }

    #main-menu-mobile-hidden .nav-item{
        box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);
        background-color: white;
        margin: 1px;
    }
    
    
    /* скрываем выпадающие списки по умолчанию
    * и задаем абсолютное позиционирование */
    ul ul {
       display: none;
       position: absolute;
       top: 100%;
    }

    /* отображаем выпадающий список при наведении */
    ul li:hover > ul {
        margin-left: -30px;
        margin-top: -3px;
        display:inherit;
        color: white;
    }

    /* первый уровень выпадающего списка */
    ul ul li {
        min-width:220px;
        float:none;
        display:list-item;
        position: relative;
        list-style: none;
        text-align: left;
        padding-left: 15px;
        padding-top: 5px;
        padding-bottom: 5px;
        list-style-type: none;
    }
    
    ul ul li:hover {
        color: #85bae2;
    }    
    
    li {
        list-style-type: none;
    }
    
    #content{
        box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);
        background-color: #fff;
        /*min-height: 100vh;*/
        /*background-image: url("/img/background-content.png");*/
        padding: 0;
        margin: 0;
        border-radius: 0 0 0 0;
    }

    .table-bordered{
        border: 1px solid gray;
    }
    .table-bordered thead th{
        border: 1px solid gray;
        border-bottom: 1px solid gray;
        border-bottom-color: gray;
    }
    .table-bordered tbody td{
        border: 1px solid gray;
    }
    
    #app {
    }
    
    .header{
        float: left;
        background-color: #fff;
        box-shadow: 0.0px -5.0px 5px rgba(122,122,122,0.5);
        border-radius: 0 0 0 0;
    }
    
    .app-main-component{
        background-color: #FFFFFF;
        padding: 5px;
        margin: 0;
        margin-top: 2pt;
        margin-bottom: 2pt;
        
        border-radius: 3pt;
        
        /*box-shadow: 0 0 2pt rgba(122,122,122,0.5);;*/
        
    }
    
    #app-logo-link{
        padding: 0;
    }
    
    .app-title{
        white-space: nowrap;
    }
    
</style>









